<template>
  <div class="BulkImportCom">
    <el-button size="small" type="primary" @click="flag = true">
      {{ btnTxt }}
    </el-button>
    <el-dialog
      :visible.sync="flag"
      :title="btnTxt"
      :append-to-body="true"
      :destroy-on-close="true"
      :center="true"
      width="30%"
    >
      <el-form>
        <el-form-item>
          <p>
            没有下载模板?
            <span v-if="btnTxt === '批量添加'">
              <el-button type="text" size="small">
                <a
                  href="https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/studentExport.xlsx"
                  target="_blank"
                  download="批量添加学生.xlsx"
                  >猛戳这里</a
                >
              </el-button>
            </span>
            <span v-if="btnTxt === '学生批量换班'">
              <el-button type="text" size="small">
                <a
                  href="https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/update_studentExport.xlsx"
                  download="批量添加学生.xlsx"
                  >猛戳这里</a
                >
              </el-button>
            </span>
          </p>
        </el-form-item>
        <el-form-item label="上传Excel:">
          <el-upload
            v-if="btnTxt == '批量添加'"
            :action="`${urls}/import/import-student`"
            :headers="{ token: token }"
            accept=".xls, .xlsx"
            :data="{ schoolId: schoolId }"
            :on-success="uploadFileStudentSuccess"
          >
            <el-button size="small">
              <i class="el-icon-upload"></i> 选择文件
            </el-button>
          </el-upload>

          <el-upload
            v-if="btnTxt === '学生批量换班'"
            :action="`${urls}/import/batchupdate-student`"
            :headers="{ token: token }"
            accept=".xls, .xlsx"
            :data="{ schoolId: schoolId }"
            :on-success="uploadFileStudentSuccess"
          >
            <el-button size="small">
              <i class="el-icon-upload"></i> 选择文件
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label=" 备注:"
          >新增学生成功后，学生使用学籍号登录，初始密码为
          学籍号后六位</el-form-item
        >
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { urls } from "@/api/home";
export default {
  name: "BulkImportStudentCom",
  props: {
    btnTxt: {
      type: String,
      default: "批量添加"
    },
    token: {
      type: String
    },
    schoolId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      flag: false,
      urls:urls,
    };
  },
  methods: {
    uploadFileStudentSuccess(response, file, fileList) {
      if (response.data.errorMsgs) {
        const h = this.$createElement;
        this.$notify.info({
          title: "提示信息",
          message: h("div", { style: { width: "500px" } }, [
            h("h4", "成功信息"),
            h("div", `成功导入${response.data.scount}信息`),
            h("h4", "错误信息"),
            h(
              "el-table",
              {
                style: {
                  width: "500px"
                },
                props: {
                  data: response.data.errorMsgs,
                  border: true,
                  height: 300
                }
              },
              [
                h("el-table-column", {
                  props: {
                    label: "错误行数",
                    width:"100",
                    prop: "row"
                  }
                }),
                h("el-table-column", {
                  props: {
                    label: "错误信息",
                    width:"399",
                    prop: "msg"
                  }
                })
              ]
            )
          ]),
          duration: 0
        });
        this.$emit("updateList");
      } else {
        this.$message.success("导入成功");
        this.$emit("updateList");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/school/components/components/studentImport.vue